module.exports = __webpack_public_path__ + "static/Basil-&-Fetta-8878e5e03651bf6b09d63ecdf0c31ac7.png";